import {html, css, LitElement} from "../libs/lit.dist.js";
import {createAlert} from "./pk-alert-dialog.js";
import {createInitTooltip, destroyTooltip} from "../util/browser.js";

export class PkTooltipIcon extends LitElement {

    static defaultIconCollection = 'fal';
    static defaultIcon = 'question-circle';

    static properties = {
        content: {type: String},
        icon: {type: String},
        iconCollection: {type: String},
        buttonLabel: {type: String},
        destructive: {type: Boolean},
    };

    static styles = css`
        :host {
            cursor: pointer;
            display: inline-block;
            background: none;
            border: none;
            padding: var(--padding, 0.25rem) calc(var(--padding, 0.25rem) * 1.25);
            font-size: var(--font-size, 0.875rem);
            margin: 0;
            border-radius: 4px;
            
        }
        :host(:active),
        :host(:focus) {
            box-shadow: 0 0 0 0.25rem color(from var(--gray-500) xyz x y z / 0.25);
        }

        @media (max-width: 576px) {
            :host {
                --padding: 0.5rem;
            }
        }
    `;

    constructor() {
        super();
        this.icon = this.constructor.defaultIcon;
        this.iconCollection = this.constructor.defaultIconCollection;
    }

    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'button');
        this.addEventListener('mouseenter', this.#onMouseEnter);
        this.addEventListener('click', this.#onClick);
    }

    #onMouseEnter(e) {
        createInitTooltip({
            title: this.content,
            html: true,
        })(e);
    }

    #onClick() {
        return createAlert(this.title || '', this.content || '', [{
            label: this.buttonLabel || 'Ok',
            primary: this.destructive || true,
            destructive: this.destructive || false,
        }]);
    }

    update(h) {
        super.update(h);
        if (h.has('content')) {
            this.setAttribute('aria-label', this.content);
            try {
                destroyTooltip(this);
            } catch (e) {}
        }
    }

    render() {
        return html`
            <slot>
                <pk-icon collection="${this.iconCollection}" icon="${this.icon}"></pk-icon>
            </slot>
        `;
    }
}

customElements.define('pk-tooltip-icon', PkTooltipIcon);
